    import { createAppSlice } from '../../app/createAppSlice'

    const initialState = {
        context: "FEvIR Platform"//"Computable Publishing"
    };

    const environmentSlice = createAppSlice({
        name: "environment",
        initialState,
        reducers: create => ({
            changeEnvironment: create.reducer((state, action) => {
                state.context = action.payload
            }),
        }),
        selectors: {
            selectEnvironment: environment => environment.context,
        },
    })
    
    export const { changeEnvironment } = environmentSlice.actions
    
    export const { selectEnvironment } = environmentSlice.selectors
    
    export default environmentSlice